import { Space } from 'antd';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledRadioGroup = styled(Radio.Group)`
  margin-top: var(--spacing-03);
`;

const RadioItem = styled(Radio)`
  white-space: break-spaces;
  display: flex;
  .ant-radio {
    margin-top: var(--spacing-01);
  }
`;

export const RadioChoiceField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <FormItemDesc label={field.description} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <StyledRadioGroup
            ref={props.field.ref}
            value={props.field.value}
            disabled={disabled}
            onChange={(e) =>
              setValue?.(field.questionId.toString(), e.target.value)
            }
          >
            <Space direction="vertical">
              {field.options?.map((option) => {
                return (
                  <RadioItem value={option.optionId}>
                    {option.optionLabel}
                  </RadioItem>
                );
              })}
            </Space>
          </StyledRadioGroup>
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
    </FormItemWrapper>
  );
};
